"use client";
import { Chip as DigDirChip } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const ChipRemovable = React.forwardRef(({ className, hero, "data-color": dataColor, "data-size": dataSize, ...props }, ref) => {
    return (React.createElement(DigDirChip.Removable, { ref: ref, className: cn("in-chip__removable", hero && "in-chip-hero", className), "data-size": hero ? "lg" : dataSize, "data-color": hero ? "primary" : dataColor, ...props }));
});
ChipRemovable.displayName = "ChipRemovable";
export { ChipRemovable };
//# sourceMappingURL=chipRemovable.js.map